/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./demand-info.vue?vue&type=template&id=410def0f&"
import script from "./demand-info.vue?vue&type=script&lang=js&"
export * from "./demand-info.vue?vue&type=script&lang=js&"
import style0 from "./demand-info.vue?vue&type=style&index=0&id=410def0f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports